import { createI18n } from "vue-i18n";
import en from "./locales/en.json";
import es from "./locales/es.json";

const messages = {
  en,
  "en-US": en,
  es,
};

const i18n = createI18n({
  locale: "es", // Idioma por defecto
  fallbackLocale: "es", // Idioma de respaldo
  messages,
  // TODO: Quitar en prd, se necesita traducción de toda la pagina
  missingWarn: false,
  fallbackWarn: false,
  warnHtmlMessage: false,
  silentFallbackWarn: true,
  globalInjection: true,
});

export default i18n;
